import { render } from "./App.vue?vue&type=template&id=7b5ebdea&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7b5ebdea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7b5ebdea"

export default script